import { getGlobalData } from "../lib/globalData"

const ArchiveProj = props => {
  const { dataprovider, proj } = props;
  const token = getGlobalData('token');
  return (
  <div className="modal fade" id="archiveproj" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="archiveproj" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">Projekt archivieren</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
          Du kannst das Projekt <i>&laquo;{props.name}&raquo;</i> als Archiv herunterladen:
        </div>
        <div className="modal-footer">
        <a href={'https://'+dataprovider.apiUrl+"/archive/"+proj+"?token="+token} className="btn btn-primary" target="_blank" rel="noreferrer">Projektarchiv herunterladen</a>
        </div>
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">Projekt wiederherstellen</h5>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label htmlFor="formFile" className="form-label">Archivdatei hochladen</label>
            <input className="form-control" type="file" id="formFile" />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={props.ArchiveeteProject}>Projekt importieren</button>
        </div>
      </div>
    </div>
  </div>
  )
}
export default ArchiveProj;